import { useState, useEffect } from 'react';
import styles from '../../styles/SlideShow.module.css';

export default function SlideShow({ side, images }) {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [fade, setFade] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            setFade(false);
            setTimeout(() => {
                setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
                setFade(true);
            }, 500);
        }, 5000);

        return () => clearInterval(interval);
    }, [images.length]);

    return (
        <div style={{ overflow: 'hidden' }}>
            <img
                src={images[currentImageIndex]}
                alt="slideshow"
                style={{
                    width: '600px',
                    height: 'auto',
                    objectFit: 'contain',
                    opacity: fade ? 1 : 0,
                    transition: 'opacity 0.5s ease-in-out',
                }}
                className={side === 'right' ? styles.slideRight : styles.slideLeft}
            />
        </div>
    );
}
